import { useEffect, useRef, useState } from "react";
import { getSubscriptionLink } from "../../../../utils/Constantes";

// Section « Abonnement via Stripe » du détail client : le lien de paiement
// propre à cet utilisateur, à lui transmettre.
export default function SubscriptionLinkSection({ uid }: { uid?: string }) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [copied, setCopied] = useState(false);

  // Le message « Lien copié » s'efface de lui-même.
  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(t);
  }, [copied]);

  // Sans UID, un lien incomplet rattacherait le paiement à personne : mieux
  // vaut ne rien proposer.
  if (!uid) return null;
  const link = getSubscriptionLink(uid);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
    } catch {
      // L'API presse-papiers exige un contexte sécurisé (HTTPS) : à défaut,
      // on sélectionne le texte pour permettre un Ctrl+C manuel.
      inputRef.current?.select();
    }
  };

  return (
    <div>
      <h3 className="title-card-dashbord-view mb-2">Abonnement via Stripe</h3>
      <p className="mb-3" style={{ fontSize: 14 }}>
        Veuillez copier et envoyer ce lien à l'utilisateur
      </p>
      <div className="d-flex flex-wrap align-items-center gap-2">
        <input
          ref={inputRef}
          type="text"
          readOnly
          value={link}
          onFocus={(e) => e.target.select()}
          className="form-control"
          style={{ flex: "1 1 320px", fontFamily: "monospace", fontSize: 14 }}
          aria-label="Lien d'abonnement"
        />
        <button type="button" className="btn btn-see-more" onClick={onCopy}>
          {copied ? "Lien copié ✓" : "Copier le lien"}
        </button>
      </div>
    </div>
  );
}
